import { FormatOptions } from '@bitpatty/imgproxy-url-builder';

export enum ImageFormatTypes {
  JPG = 'jpg',
  JPEG = 'jpeg',
  PNG = 'png',
  WEBP = 'webp',
  TIFF = 'tiff',
  HEIF = 'heif',
  HEIC = 'heic',
  RAW = 'raw',
  GIF = 'gif',
}

interface imageFilters {
  blur?: number;
  allowUpscale?: boolean;
  grayScale?: boolean;
  quality?: number;
  format?: ImageFormatTypes | FormatOptions;
}

const aspectRatioHeight = (width: number, origWidth: number, origHeight = 0): number => {
  return origWidth === 0 ? 0 : Math.round((origHeight / origWidth) * width);
};

const getFiltersString = (filters: imageFilters): string => {
  const { format, blur, allowUpscale, grayScale, quality } = filters;

  const formatFilter = format ? `:format(${format})` : `:format(${ImageFormatTypes.WEBP})`;
  const blurFilter = blur ? `:blur(${blur})` : '';
  const allowUpScaleFilter = allowUpscale ? '' : ':no_upscale()';
  const grayScaleFilter = grayScale ? ':grayscale()' : '';
  const qualityFilter = quality && quality > 0 ? `:quality(${filters.quality})` : '';

  return `filters${formatFilter}${blurFilter}${allowUpScaleFilter}${grayScaleFilter}${qualityFilter}`;
};

export const getCloudfrontLoader = (
  src: string,
  width: number,
  origWidth: number,
  origHeight = 0,
  filters: imageFilters = {},
): string => {
  const parts = src.split('/');
  const hostName = parts[2];
  const id = parts[parts.length - 1];
  const height = aspectRatioHeight(width, origWidth, origHeight);
  const filtersSet = getFiltersString(filters);

  return `https://${hostName}/${width}x${height}/smart/${filtersSet}/${id}`;
};
